'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Calendar;

module.exports = Calendar = function () {
  function Calendar(date, options) {
    _classCallCheck(this, Calendar);

    this.date = date || new Date();
    this.options = {
      minDate: null,
      maxDate: null,
      yearRange: 10,
      i18n: {
        previousMonth: 'Previous Month',
        nextMonth: 'Next Month',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        weekdays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      }
    };
  }

  _createClass(Calendar, [{
    key: 'getDaysInMonth',
    value: function getDaysInMonth(year, month) {
      return [31, this.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    }
  }, {
    key: 'isLeapYear',
    value: function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
  }, {
    key: 'isWeekend',
    value: function isWeekend(date) {
      var day;
      day = date.getDay();
      return day === 0 || day === 6;
    }
  }, {
    key: 'isDate',
    value: function isDate(obj) {
      return (/Date/.test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime())
      );
    }
  }, {
    key: 'prevMonth',
    value: function prevMonth() {
      return this.date.setMonth(this.getMonth() - 1);
    }
  }, {
    key: 'nextMonth',
    value: function nextMonth() {
      return this.date.setMonth(this.getMonth() + 1);
    }
  }, {
    key: 'prevWeek',
    value: function prevWeek() {
      return this.date.setDate(this.date.getDate() - 7);
    }
  }, {
    key: 'nextWeek',
    value: function nextWeek() {
      return this.date.setDate(this.date.getDate() + 7);
    }
  }, {
    key: 'today',
    value: function today() {
      return this.date = new Date();
    }
  }, {
    key: 'getWeekdays',
    value: function getWeekdays() {
      return this.options.i18n.weekdays;
    }
  }, {
    key: 'getMonth',
    value: function getMonth() {
      return this.date.getMonth();
    }
  }, {
    key: 'getYear',
    value: function getYear() {
      return this.date.getFullYear();
    }
  }, {
    key: 'getDays',
    value: function getDays() {
      var ref;
      return function () {
        var results = [];
        for (var i = 0, ref = this.getDaysInMonth(this.getYear(), this.getMonth()); 0 <= ref ? i <= ref : i >= ref; 0 <= ref ? i++ : i--) {
          results.push(i);
        }
        return results;
      }.apply(this);
    }
  }, {
    key: 'firstDay',
    value: function firstDay() {
      return new Date(this.getYear(), this.getMonth(), 0).getDay() - 1;
    }
  }, {
    key: 'getWeekOfMonth',
    value: function getWeekOfMonth() {
      var i, index, week;
      week = new Date(this.getYear(), this.getMonth(), 0 - this.firstDay() - 1);
      for (index = i = 0; i <= 7; index = ++i) {
        if (this.date < week) {
          return index - 2;
        }
        week = new Date(week.setDate(week.getDate() + 7));
      }
    }
  }, {
    key: 'getYears',
    value: function getYears() {
      var _this = this;

      var ref, ref1;
      return function () {
        var results = [];
        for (var i = ref = -this.options.yearRange, ref1 = this.options.yearRange; ref <= ref1 ? i <= ref1 : i >= ref1; ref <= ref1 ? i++ : i--) {
          results.push(i);
        }
        return results;
      }.apply(this).map(function (year) {
        return _this.date.getFullYear() + year;
      });
    }
  }, {
    key: 'getWeeks',
    value: function getWeeks() {
      var daycount, gridStart, month, nextmonth, prevMonth, prevMonthLength, total, year;
      year = this.getYear();
      month = this.getMonth();
      prevMonth = new Date(year, month, 0, 0, 0, 0);
      prevMonthLength = this.getDaysInMonth(prevMonth.getFullYear(), prevMonth.getMonth());
      total = this.getDaysInMonth(year, month);
      gridStart = new Date(year, month, 0 - this.firstDay() - 1);
      daycount = 0;
      nextmonth = 0;
      return [0, 1, 2, 3, 4, 5].map(function (weeknum) {
        return [0, 1, 2, 3, 4, 5, 6].map(function (daynum) {
          return gridStart = new Date(gridStart.getFullYear(), gridStart.getMonth(), gridStart.getDate() + 1, 0, 0, 0, 0);
        });
      });
    }
  }, {
    key: 'getDate',
    value: function getDate() {
      return this.date;
    }
  }, {
    key: 'setDay',
    value: function setDay(day) {
      return this.date.setDate(day);
    }
  }, {
    key: 'setMonth',
    value: function setMonth(month) {
      return this.date.setMonth(month);
    }
  }, {
    key: 'setYear',
    value: function setYear(year) {
      return this.date.setYear(year);
    }
  }, {
    key: 'repeat',
    value: function repeat(start, end) {
      var _repeat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'daily';

      var dates, dt, inc, maxdays;
      dt = new Date(start);
      dates = [];
      if (_repeat === "daily") {
        inc = function inc(dt) {
          return new Date(dt.getTime() + 24 * 60 * 60 * 1000);
        };
      }
      if (_repeat === "weekly") {
        inc = function inc(dt) {
          return new Date(dt.getTime() + 7 * 24 * 60 * 60 * 1000);
        };
      }
      if (_repeat === "fortnightly") {
        inc = function inc(dt) {
          return new Date(dt.getTime() + 14 * 24 * 60 * 60 * 1000);
        };
      }
      if (_repeat === "monthly") {
        inc = function inc(dt) {
          return new Date(new Date(dt).setMonth(dt.getMonth() + 1));
        };
      }
      maxdays = 500;
      if (!inc) {
        return [start];
      }
      while (new Date(dt).setHours(0, 0, 0) < new Date(end).setHours(0, 0, 0)) {
        maxdays--;
        if (maxdays < 0) {
          return dates;
        }
        dates.push(dt);
        dt = inc(dt);
      }
      dates.push(end);
      return dates;
    }
  }, {
    key: 'isToday',
    value: function isToday(compareDate) {
      var am, pm;
      if (!compareDate) {
        return false;
      }
      am = compareDate.setHours(0, 0);
      pm = compareDate.setHours(23, 59);
      if (this.date.getTime() >= am && this.date.getTime() <= pm) {
        return true;
      } else {
        return false;
      }
    }
  }]);

  return Calendar;
}();